import { RefObject, useEffect, useRef } from "react";

import useStickyTransform from "./useStickyTransform";

const useStickyRow = (
  isActiveSticky?: boolean,
  nextAfterSticky?: number,
  tableRef?: RefObject<HTMLDivElement | null>
) => {
  const rowRef = useRef<HTMLDivElement | null>(null);
  const { updateTransform, cleanup, reset } = useStickyTransform();

  useEffect(() => {
    const tableElement = tableRef?.current;
    const rowElement = rowRef.current;

    if (!isActiveSticky || !nextAfterSticky || !tableElement) {
      // No longer pinned: drop any leftover transform so the row returns to its normal position.
      reset(rowElement);

      return undefined;
    }

    const handleScrollEvent = (event: Event) => {
      updateTransform(
        rowElement,
        (event.currentTarget as HTMLDivElement).scrollTop,
        nextAfterSticky
      );
    };

    tableElement.addEventListener("scroll", handleScrollEvent, { passive: true });

    return () => {
      tableElement.removeEventListener("scroll", handleScrollEvent);
      cleanup();
    };
  }, [isActiveSticky, nextAfterSticky, tableRef, updateTransform, cleanup, reset]);

  return rowRef;
};

export default useStickyRow;
